import { ICON_TYPES } from '../constants';

export const ContactIcon = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72.8 50.4">
      <path d="M5.6,50.4a5.565,5.565,0,0,1-1.661-.253,2.81,2.81,0,0,0,.721-.455l24.212-21.52,5.736,4.779a2.8,2.8,0,0,0,3.585,0l5.736-4.779L68.14,49.692a2.771,2.771,0,0,0,.721.455,5.561,5.561,0,0,1-1.66.253Zm66.26-4.892L48.279,24.546,71.792,4.951a2.775,2.775,0,0,0,.755-1.013A5.547,5.547,0,0,1,72.8,5.6V44.8a5.573,5.573,0,0,1-.251,1.652A2.782,2.782,0,0,0,71.86,45.508ZM0,44.8V5.6A5.575,5.575,0,0,1,.252,3.938a2.768,2.768,0,0,0,.755,1.013L24.521,24.546.94,45.508a2.77,2.77,0,0,0-.689.945A5.573,5.573,0,0,1,0,44.8ZM4.592.648A2.758,2.758,0,0,0,3.936.254,5.565,5.565,0,0,1,5.6,0H67.2a5.6,5.6,0,0,1,1.664.253,2.828,2.828,0,0,0-.656.4L36.4,27.155Z" />
    </svg>
  );
};

ContactIcon.iconType = ICON_TYPES.CONTACT_ICON;
